import Box, { BoxProps } from "@mui/material/Box";
import { FC, memo } from "react";

const FlexCenter: FC<BoxProps> = (props) => (
  <Box display="flex" alignItems="center" {...props}>
    {props.children}
  </Box>
);

export default memo(FlexCenter);
